<template>
    <form-element style="display: flex; flex-direction: column;flex-grow:1; min-width: 320px;">
        <h2 style="text-align:center">Wertung Pr&auml;sentation</h2>
        <div id="Wertung" style="text-align:center">
            <h1 class="wertungfont">{{ valueGesamt }}</h1>
        </div>

        <div id="Kreativitaet" class="wertungSliderElement">
            <div><h4>Kreativit&auml;t&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueKreativitaet }}</h4></div>
            <div id="ContainerKreativitaet" class="wertungSliderContainer">
                <slider :buttons="true"
                        :step="0.1"
                        :default-value="0"
                        :min="0.5"
                        :max="2"
                        :value="valueKreativitaet"
                        @change="onChangeKreativitaet"
                        class="sliderKRWertung">
                    <slider-label :title="valueKreativitaet.toString()"
                                  :key="valueKreativitaet"
                                  @click="handleClickKreativitaet(valueKreativitaet)"
                                  :position="valueKreativitaet"
                                  v-for="valueKreativitaet in [ 0.5, 0.8, 1.1, 1.4, 1.7, 2 ]">
                    </slider-label>
                </slider>
            </div>
        </div>
        <div id="Effektivitaet" class="wertungSliderElement">
            <div><h4>Effektivitaet&nbsp;&nbsp;-&nbsp;&nbsp;{{ valueEffektivitaet }}</h4></div>
            <div id="ContainerEffektivitaet" class="wertungSliderContainer">
                <slider :buttons="true"
                        :step="0.1"
                        :default-value="0"
                        :min="0.5"
                        :max="2"
                        :value="valueEffektivitaet"
                        @change="onChangeEffektivitaet"
                        class="sliderKRWertung">
                    <slider-label :title="valueEffektivitaet.toString()"
                                  :key="valueEffektivitaet"
                                  @click="handleClickEffektivitaet(valueEffektivitaet)"
                                  :position="valueEffektivitaet"
                                  v-for="valueEffektivitaet in [ 0.5, 0.8, 1.1, 1.4, 1.7, 2  ]">
                    </slider-label>
                </slider>
            </div>
        </div>
    </form-element>
</template>
<script>
    import { FormElement } from '@progress/kendo-vue-form';
    import { Slider, SliderLabel } from '@progress/kendo-vue-inputs';
    import store from '@/store/store.js';

    export default {
        components: {
            'form-element': FormElement,
            'slider': Slider,
            'slider-label': SliderLabel,
            store
        },
        data() {
            return {
                valueGesamt: 2.6,
                valueKreativitaet: 1.3,
                valueEffektivitaet: 1.3
            };
        },
        props: {
            reset: Number,
        },
        watch: {
            reset() {
                console.log('Reset');
                this.valueGesamt = 2.6
                this.valueKreativitaet = 1.3;
                this.valueEffektivitaet = 1.3;
                this.kendoForm.onFormReset();
            },
        },
        mounted() {
            //Falls keine �nderung erfolgt!
            store.teilnehmer_WertungPraesentation = this.valueKreativitaet + this.valueEffektivitaet;
        },
        methods: {
            onChangeKreativitaet(event) {
                this.valueKreativitaet = Number(event.value.toFixed(1));
                this.valueGesamt = this.valueKreativitaet + this.valueEffektivitaet;
                this.valueGesamt = this.valueGesamt.toFixed(1);
                store.teilnehmer_WertungPraesentation = this.valueGesamt;
                console.log("--------> Praesentation:", store.teilnehmer_WertungPraesentation)
            },
            onChangeEffektivitaet(event) {
                this.valueEffektivitaet = Number(event.value.toFixed(1));
                this.valueGesamt = this.valueKreativitaet + this.valueEffektivitaet;
                this.valueGesamt = this.valueGesamt.toFixed(1);
                store.teilnehmer_WertungPraesentation = this.valueGesamt;
                console.log("--------> Praesentation:", store.teilnehmer_WertungPraesentation)
            },
            handleClickKreativitaet(valueKreativitaet) {
                this.valueKreativitaet = valueKreativitaet.toFixed(1);
            },
            handleClickEffektivitaet(valueEffektivitaet) {
                this.valueEffektivitaet = valueEffektivitaet.toFixed(1);
            },
        }
    };
</script>
